import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// تأكد من صحة مسار استيراد الأكشن
import { loginUser } from "../services/authServices/loginService";
import { CenterContent, VList } from "../utils/layouts";
import Loader from "../utils/Loader";

const LoginPage = ({ setIsAuthenticated }) => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // جلب حالة التحميل من Redux
  const isLoading = useSelector((state) => state.auth?.loading);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!userId || !password) {
      setError("يرجى إدخال اسم المستخدم وكلمة المرور");
      return;
    }

    setError("");

    try {
      // إرسال البيانات المدخلة من الفورمة إلى Redux
      const data = await dispatch(loginUser({ userId, password })).unwrap();

      // التخزين في الذاكرة المحلية (التوكن يتم حفظه في الـ Slice)
      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data?.user));
      }
      localStorage.setItem("isLoggedIn", "true");

      // تحديث حالة المصادقة والتوجيه للصفحة الرئيسية
      setIsAuthenticated(true);
      navigate("/");
    } catch (err) {
      setError(err || "حدث خطأ أثناء محاولة تسجيل الدخول");
    }
  };

  return (
    <CenterContent minHeight="100vh">
      <Paper variant="section" sx={{ width: "350PX" }}>
        <Box component="form" onSubmit={handleLogin} noValidate>
          <VList>
            <Typography variant="sectionTitle">تسجيل الدخول</Typography>

            {error && (
              <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
                {error}
              </Alert>
            )}

            <TextField
              variant="outlined"
              required
              size="small"
              fullWidth
              placeholder="اسم المستخدم (رقم المعرف)"
              autoFocus
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              disabled={isLoading}
            />

            <TextField
              required
              variant="outlined"
              size="small"
              fullWidth
              placeholder="كلمة المرور"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                      disabled={isLoading}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              size="small"
              sx={{ m: "auto" }}
              disabled={isLoading}
            >
              {isLoading ? <Loader color="inherit" /> : "دخول"}
            </Button>
          </VList>
        </Box>
      </Paper>
    </CenterContent>
  );
};

export default LoginPage;
